/**
 * MarketQuickSearch.js
 * 版本：V1.01 | 更新日期：2025-07-16 16:00:00
 * 功能：市場快速搜尋組件，提供市場查詢和拜訪記錄功能
 * 關連檔案：App.js, SearchResultModal.js
 */

import React, { useState, useEffect, useMemo } from 'react';

const MarketQuickSearch = ({ markets, bookings, onSearchResult }) => {
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedMarketId, setSelectedMarketId] = useState('');
    
    const cities = useMemo(() => [...new Set(markets.map(m => m.city))].sort(), [markets]);
    const filteredMarkets = useMemo(() => {
        if (!selectedCity) return markets.sort((a, b) => a.name.localeCompare(b.name, 'zh-Hant'));
        return markets.filter(m => m.city === selectedCity);
    }, [selectedCity, markets]);

    useEffect(() => {
        if (selectedMarketId) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const marketBookings = bookings
                .filter(b => b.marketId === selectedMarketId)
                .sort((a, b) => new Date(a.date) - new Date(b.date));

            const pastBookings = marketBookings.filter(b => new Date(b.date) < today);
            const futureBookings = marketBookings.filter(b => new Date(b.date) >= today);
            
            const lastVisit = pastBookings.length > 0 ? pastBookings[pastBookings.length - 1].date : null;
            const nextVisit = futureBookings.length > 0 ? futureBookings[0].date : null;

            onSearchResult({
                isOpen: true,
                data: {
                    marketName: markets.find(m => m.id === selectedMarketId)?.name || '',
                    lastVisit,
                    nextVisit
                }
            });

            setSelectedMarketId(''); 
            setSelectedCity('');
        }
    }, [selectedMarketId, bookings, markets, onSearchResult]);

    return (
        <div className="my-4 p-4 bg-gray-50 rounded-lg border">
            <h3 className="text-md font-bold text-gray-800 mb-2">🎯 市場快速查詢</h3>
            <div className="flex flex-col sm:flex-row gap-2">
                <select 
                    value={selectedCity} 
                    onChange={e => setSelectedCity(e.target.value)}
                    className="flex-1 p-2 border rounded-md"
                >
                    <option value="">選擇縣市 (全部)</option>
                    {cities.map(city => <option key={city} value={city}>{city}</option>)}
                </select>
                <select 
                    value={selectedMarketId}
                    onChange={e => setSelectedMarketId(e.target.value)}
                    className="flex-1 p-2 border rounded-md"
                >
                    <option value="">請選擇市場...</option>
                    {filteredMarkets.map(market => <option key={market.id} value={market.id}>{market.name}</option>)}
                </select>
            </div>
        </div>
    );
};

export default MarketQuickSearch; 